import React from "react";
import { motion } from "framer-motion";
import { SERVICES } from "@/data/site";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#F2EFE9] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="overline">What we capture</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-4 max-w-2xl">
              Four specialties.
              <br />
              <span className="italic font-light">One signature.</span>
            </h2>
          </div>
          <p className="text-[#4A4A4A] max-w-sm leading-relaxed">
              From the cathedral of a wedding aisle to the hush of a private
              session — every category receives the same editorial devotion.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-6 md:gap-8">
          {SERVICES.map((s, i) => {
            // Asymmetrical grid
            const layout = [
              "md:col-span-4 md:row-span-2 h-[460px] md:h-[640px]",
              "md:col-span-2 h-[300px] md:h-[310px]",
              "md:col-span-2 h-[300px] md:h-[310px]",
              "md:col-span-6 h-[360px] md:h-[420px]",
            ][i];

            return (
              <motion.a
                key={s.id}
                href="#contact"
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: i * 0.08 }}
                className={`group relative overflow-hidden block bg-[#1A1A1A] ${layout}`}
              >
                <img
                  src={s.image}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-contain transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent transition-opacity duration-500 group-hover:from-black/90" />
                <div className="absolute inset-0 p-7 md:p-9 flex flex-col justify-end">
                  <p className="overline text-[#E6D3A3]">0{i + 1} · Service</p>
                  <h3 className="font-serif-display text-white text-3xl md:text-4xl mt-2">
                    {s.title}
                  </h3>
                  <p className="text-white/80 text-sm mt-3 max-w-sm leading-relaxed translate-y-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                    {s.blurb}
                  </p>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
